// tslint:disable
// this is an auto generated file. This will be overwritten

export const getOutlet = /* GraphQL */ `
  query GetOutlet($id: ID!) {
    getOutlet(id: $id) {
      id
      owner
      name
      description
      active
      activated
      activations
      activate
      schedule {
        items {
          id
          hour
          minute
          active
          repeat
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
        nextToken
      }
      site
      section
      sensor
    }
  }
`;
export const listOutlets = /* GraphQL */ `
  query ListOutlets(
    $filter: ModelOutletFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutlets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        description
        active
        activated
        activations
        activate
        schedule {
          nextToken
        }
        site
        section
        sensor
      }
      nextToken
    }
  }
`;
